import { render } from "./PayInCanceledDealsCountCheckDescription.vue?vue&type=template&id=1bb1fa9e&ts=true"
import script from "./PayInCanceledDealsCountCheckDescription.vue?vue&type=script&lang=ts"
export * from "./PayInCanceledDealsCountCheckDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__